export default __webpack_public_path__ + "static/media/image15.67c201a8.jpeg";